import React from 'react';
import './btn2.css';

const Btn2 = (props) => {
  return (
    <button className="btnn2" type="button">
      <span>{props.btnt}</span>

      <svg
        className="arroww2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="12 19 19 12 12 5" />
      </svg>
    </button>
  );
};

export default Btn2;